import { QuantifyTableViewGrid } from '@modules/quantify/components/QuantifyTableView/QuantifyTableViewGrid';
import { Box } from '@mui/material';
import { useMeasure } from 'react-use';

interface QuantifyTableViewContentProps {
  shouldShowActions?: boolean;
  shouldShowMergeWithSelectedReasonsAction?: boolean;
}

export const QuantifyTableViewContent = ({
  shouldShowActions,
  shouldShowMergeWithSelectedReasonsAction = true,
}: QuantifyTableViewContentProps) => {
  const [tableContainerRef, { height: tableContainerHeight }] = useMeasure();

  return (
    <Box height="100%" ref={tableContainerRef}>
      <QuantifyTableViewGrid
        containerHeight={tableContainerHeight}
        shouldShowActions={shouldShowActions}
        shouldShowMergeWithSelectedReasonsAction={
          shouldShowMergeWithSelectedReasonsAction
        }
      />
    </Box>
  );
};
